import { motion } from "framer-motion";
import { Clock, BadgeCheck, Wallet, Headphones } from "lucide-react";

const ITEMS = [
    {
        Icon: Clock,
        title: "30 Dakikada Kapınızda",
        desc: "Kayseri içi ortalama varış süresi 30 dakika. Acil durumlarda öncelikli müdahale.",
    },
    {
        Icon: BadgeCheck,
        title: "İşçilik Garantili",
        desc: "Yapılan tüm işler garantilidir. Aynı sorun tekrar ederse ücretsiz tekrar geliyoruz.",
    },
    {
        Icon: Wallet,
        title: "Şeffaf Fiyat",
        desc: "İşe başlamadan önce net fiyat. Sürpriz ek ücret yok, pazarlık aramayız.",
    },
    {
        Icon: Headphones,
        title: "7/24 Telefon Desteği",
        desc: "Gece yarısı, hafta sonu, tatil — fark etmez. Telefon her zaman açık.",
    },
];

export const WhyUs = () => {
    return (
        <section
            id="hakkimizda"
            data-testid="why-us-section"
            className="relative py-20 sm:py-28 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-start">
                <div className="lg:col-span-5 lg:sticky lg:top-24">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0055FF]">
                        Neden Biz
                    </div>
                    <h2 className="mt-3 font-black tracking-tighter text-slate-900 text-3xl sm:text-4xl lg:text-5xl leading-[1.02]">
                        Kayseri'de en çok <span className="text-[#0055FF]">tercih edilen tesisatçı</span>.
                    </h2>
                    <p className="mt-4 text-slate-600 text-base sm:text-lg">
                        Yılların deneyimi, modern ekipman ve dürüst hizmet anlayışıyla yanınızda olan
                        bir <strong className="text-slate-900">su tesisatçısı</strong> servisi.
                    </p>
                </div>

                <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
                    {ITEMS.map((item, idx) => (
                        <motion.div
                            key={item.title}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: idx * 0.08 }}
                            data-testid={`why-item-${idx}`}
                            className="group rounded-2xl border border-slate-200 bg-white p-6 hover:border-[#0055FF]/40 hover:shadow-lg transition-all"
                        >
                            <div className="w-11 h-11 rounded-xl bg-[#E5EDFF] flex items-center justify-center transition-transform group-hover:rotate-6 group-hover:scale-110">
                                <item.Icon className="w-5 h-5 text-[#0055FF]" strokeWidth={2.5} />
                            </div>
                            <h3 className="mt-4 font-extrabold tracking-tight text-slate-900 text-lg">
                                {item.title}
                            </h3>
                            <p className="mt-1.5 text-slate-600 text-sm leading-relaxed">
                                {item.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyUs;
